<template>
  <div class="c-app app header-fixed sidebar-fixed sidebar-lg-show">
    <ThePageHeader />
    <TheSidebar
      :key="`sidebar_${$store.state.language}`"
      :translations="translationsObject"
    />
    <CWrapper>
      <div class="c-body">
        <main class="c-main">
          <MzBreadcrumbRouter
            :translations="translationsObject"
            :showFullScreenButton="false"
            class="mb-0 ml-0"
            :key="`breadcrumbs_${$store.state.language}`"
          />
          <CContainer fluid :key="`view_${$store.state.language}`">
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter />
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheFooter from "./TheFooter";
import ThePageHeader from "./ThePageHeader";

import { translationsObject } from "@/constants/translations";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheFooter,
    ThePageHeader,
  },
  data() {
    return {
      translationsObject,
    };
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
